import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  standalone: false,
  selector: 'app-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  @ViewChild('container', { static: true }) container: ElementRef;
  
  @Input() type: string = '';
  @Output() confirm = new EventEmitter<any>();

  constructor(
    private modalService: NgbModal,
    ) { }

  ngOnInit(): void {
  }

  open() {
    this.modalService.open(this.container, { ariaLabelledBy: 'modal-basic-title' });
  }

  close() {
    this.modalService.dismissAll('Closed');
  }

  sendEvent() {
    this.confirm.emit();
  }

}
